import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function DeleteAccount() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M10.709 4.814l-.636.998h4.854l-.636-.998a.27.27 0 00-.224-.127H10.93a.262.262 0 00-.225.127h.004zm4.922-.935l1.228 1.933h2.337c.446 0 .804.377.804.844 0 .468-.358.844-.804.844h-.267v10.688c0 1.553-1.2 2.812-2.679 2.812h-7.5c-1.48 0-2.679-1.259-2.679-2.813V7.5h-.267C5.358 7.5 5 7.124 5 6.656c0-.467.358-.843.804-.843H8.14l1.228-1.938A1.86 1.86 0 0110.93 3h3.138c.626 0 1.212.33 1.56.875l.004.004zM7.679 7.5v10.688c0 .622.478 1.125 1.071 1.125h7.5c.593 0 1.071-.503 1.071-1.125V7.5H7.68zm2.678 2.25v7.313c0 .309-.24.562-.536.562a.551.551 0 01-.535-.563V9.75c0-.31.24-.563.535-.563.295 0 .536.254.536.563zm2.679 0v7.313c0 .309-.241.562-.536.562a.551.551 0 01-.536-.563V9.75c0-.31.241-.563.536-.563.295 0 .536.254.536.563zm2.678 0v7.313c0 .309-.24.562-.535.562a.551.551 0 01-.536-.563V9.75c0-.31.24-.563.536-.563.294 0 .535.254.535.563z"
        fill={Styles.Colors.PayNew.black01}
      />
    </Svg>
  );
}

const DeleteAccountIcon = React.memo(DeleteAccount);

export default DeleteAccountIcon;
